module.exports = __webpack_public_path__ + "static/media/jack_summit_intro_small_2.3ed7fa1c.jpg";